import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_LANGUAGE, getDefaultText, Language, MultilanguageText } from '../../../../../common/dto/languages.dto';

@Pipe({
  name: 'multilang',
  pure: true,
})
export class MultilangTextPipe implements PipeTransform {
  transform(value: MultilanguageText | undefined, defaultLanguage: Language = DEFAULT_LANGUAGE): string {
    return getDefaultText(value, defaultLanguage);
  }
}
